export default "__VITE_ASSET__d6a91415__"